import React from 'react';
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import { useMouseDownEvent } from '../../../../../state/analytics/useLinkClicked';
/**
 * @private
 * @deprecated Remove when cleaning up fg `platform-smart-card-remove-legacy-button` - EDM-12433
 */
var LinkInfoButton = function LinkInfoButton(_ref) {
  var content = _ref.content,
    href = _ref.href,
    icon = _ref.icon,
    onClick = _ref.onClick,
    target = _ref.target,
    testId = _ref.testId;
  var onMouseDown = useMouseDownEvent();
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: content,
    hideTooltipOnClick: true,
    tag: "span",
    testId: "".concat(testId, "-tooltip")
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    href: href,
    iconBefore: icon,
    onClick: onClick,
    onMouseDown: onMouseDown,
    spacing: "none",
    target: target,
    testId: "".concat(testId, "-button")
  }));
};
export default LinkInfoButton;